export interface LocaleApiModel {
  id: string;
  code: string;
  name: string;
}
